module.exports = __webpack_public_path__ + "static/media/multiple-choice-timed-fall.229665e4.svg";